import React from 'react';

// Types
export interface Props {}

const Arrow: React.FC<Props> = ({}) => {
    return (
        <div className="mt-12 hidden justify-end lg:flex">
            <svg
                width="84"
                height="35"
                viewBox="0 0 84 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M75.3558 21.898C73.2258 24.148 71.0258 26.328 68.9958 28.668C67.8958 29.938 67.0457 31.438 66.2257 32.908C66.0057 33.298 66.1157 34.268 66.3957 34.458C66.8257 34.738 67.6657 34.768 68.1357 34.528C69.0157 34.078 69.8757 33.468 70.5357 32.738C71.9157 31.198 73.2057 29.568 74.4457 27.898C77.0857 24.338 79.7158 20.768 82.2458 17.138C82.8458 16.278 83.2457 15.198 83.4057 14.168C83.4857 13.668 82.9357 12.668 82.4757 12.528C75.1357 10.298 67.7457 8.188 60.0157 7.868C58.7657 7.818 57.2257 8.298 56.2757 9.078C54.8557 10.238 55.2658 11.378 57.0658 11.868C61.2858 13.018 65.5258 14.088 69.7558 15.198C70.3558 15.358 70.9457 15.568 71.5357 16.098C68.6657 16.298 65.7857 16.458 62.9157 16.698C44.2057 18.308 27.1657 13.168 11.0857 4.008C8.77573 2.688 6.42577 1.43801 4.00577 0.338006C2.28577 -0.441994 1.14574 0.158004 0.285742 1.828C-0.234258 2.848 -0.0542631 3.548 0.905737 4.258C11.7257 12.148 23.3657 18.218 36.5757 21.138C45.9557 23.208 55.3357 22.928 64.7757 21.918C67.4257 21.638 70.0858 21.438 72.7358 21.258C73.5258 21.208 74.3258 21.328 75.1258 21.368C75.2058 21.538 75.2858 21.718 75.3558 21.898Z"
                    fill="black"
                />
            </svg>
        </div>
    );
};

export default Arrow;
